<template>
  <div class="pb-3">
    <div class="container">
      <h1>Health Survey</h1>
      <h3 class="text-danger">All questions are required.</h3>
    </div>
    <div class="container questions" v-for="q in qlist" :key="q.order">
      <div class="row">
        <div class="col col-1">{{ q.order }}.</div>
        <div class="col">{{ q.text }}</div>
      </div>
      <div class="row pb-3">
        <div class="col col-1">&nbsp;</div>
        <div class="col">
          <button
            type="button"
            class="btn"
            :class="{'btn-secondary': q.response  === null || q.response === 'No', 'btn-primary': q.response === 'Yes'}"
            @click="q.response = 'Yes'"
          >
            Yes
          </button>
          <button
            type="button"
            class="btn ml-1"
            :class="{'btn-secondary': q.response  === null || q.response === 'Yes', 'btn-primary': q.response === 'No'}"
            @click="q.response = 'No'"
          >
            No
          </button>
        </div>
      </div>
    </div>
    <div>
      <div class="mx-auto pb-2">
        <button
          class="btn btn-primary"
          :disabled="!canSubmit"
          @click="submit"
        >Submit</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Survey',
  data () {
    return {
      questions: [
        {
          order: 1,
          name: "cough",
          text: "Within the last 14-days, have you experienced a new cough that you cannot attribute to another health condition?",
          response: null
        },
        {
          order: 2,
          name: "shortness",
          text: "Within the last 14-days, have you experienced new shortness of breath that you cannot attribute to another health condition?",
          response: null
        },
        {
          order: 3,
          name: "throat",
          text: "Within the last 14-days, have you experienced a new sore throat that you cannot attribute to another health condition?",
          response: null
        },
        {
          order: 4,
          name: "aches",
          text: "Within the last 14-days, have you experienced new muscle aches that you cannot attribute to another health condition or a specific activity such as physical exercise?",
          response: null
        },
        {
          order: 5,
          name: "temperature",
          text: "Within the last 14-days, have you had a temperature at or above 100.4° or the sense of having a fever?",
          response: null
        },
        {
          order: 6,
          name: "contact", 
          text: "Within the last 14 days, have you had close contact, without the use of appropriate PPE, with someone who is currently sick with suspected or confirmed COVID-19?* (Note: Close contact is defined as within 6 feet for more than 15 consecutive minutes)",
          response: null
        }
      ]
    }
  },
  computed: {
    qlist () {
      return this.questions.slice().sort((a, b) => {
        return a.order > b.order ? 1 : -1
      })
    },
    canSubmit () {
      var valid = true
      this.questions.forEach(q => {
        valid &= q.response !== null
      })
      return valid
    }
  },
  methods: {
    submit () {
      var result = {}
      this.questions.forEach(q => {
        result[q.name] = q.response
      })
      this.$store.dispatch('saveSurvey', result)
      .then(()=> {
        this.$store.dispatch('fetchUserSurveys')
      })
    }
  }
}
</script>

<style scoped>
.questions {
  text-align: left;
}
</style>